module.exports = __webpack_public_path__ + "static/img/18b5d8a4.svg";